const ITEMS = [
  "Auto",
  "Furgoni",
  "Camion",
  "Diagnosi OBD2",
  "Centraline ECU",
  "Chat con Esperti",
  "TeamViewer",
  "Ibrido & Elettrico",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-white/5 bg-[#0E1017] py-6 select-none"
      aria-hidden="true"
    >
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span
              className={`font-display font-bold uppercase text-2xl sm:text-3xl tracking-tight px-6 ${
                i % 2 === 0 ? "text-stroke" : "text-white/85"
              }`}
            >
              {item}
            </span>
            <span className={i % 2 === 0 ? "text-volt text-xl" : "text-spark text-xl"}>⚡</span>
          </span>
        ))}
      </div>
    </div>
  );
};
